_ = require('lodash')

class RoundStrokeChartCtrl
  constructor: (@$scope) ->
    @strokeData = _.pick @$scope.$parent.playersAnalysis.players[0],
      'avg_shot_par3'
      'avg_shot_par4'
      'avg_shot_par5'

RoundStrokeChartCtrl.$inject = [
  '$scope'
]

module.exports = RoundStrokeChartCtrl


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-stroke-chart/round-stroke-chart-controller.coffee